import { Component, Input, OnInit } from "@angular/core";
import { MatSlideToggleChange } from "@angular/material/slide-toggle";
import { finalize } from "rxjs/operators";
import { EntitySettingsService } from "src/app/api/entity-settings/services/entity-settings.service";

const SETTING_NAME = "ai_document_processing";
const MORPH_MODEL = "entity";

@Component({
  selector: "app-ai-document-processing",
  templateUrl: "./ai-document-processing.component.html",
  styleUrls: ["./ai-document-processing.component.scss"],
})
export class AiDocumentProcessingComponent implements OnInit {
  @Input() entityType!: string;
  @Input() entityId!: number;

  enabled = false;
  loading = false;
  loadFailed = false;

  constructor(private settings: EntitySettingsService) {}

  ngOnInit(): void {
    this.loading = true;
    this.settings
      .getSetting(MORPH_MODEL, this.entityId, SETTING_NAME)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: (s) => {
          this.enabled = s.value === "enabled";
        },
        error: () => {
          this.loadFailed = true;
        },
      });
  }

  onToggle(event: MatSlideToggleChange): void {
    const previous = this.enabled;
    const next = event.checked;
    this.enabled = next;
    this.loading = true;

    this.settings
      .updateSetting(
        MORPH_MODEL,
        this.entityId,
        SETTING_NAME,
        next ? "enabled" : "disabled"
      )
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: (s) => {
          this.enabled = s.value === "enabled";
        },
        error: () => {
          this.enabled = previous;
        },
      });
  }
}
